import { render, staticRenderFns } from "./card-statement-descriptor.vue?vue&type=template&id=82d61af2&"
import script from "./card-statement-descriptor.vue?vue&type=script&lang=js&"
export * from "./card-statement-descriptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports